export default __webpack_public_path__ + "static/anatomy-7286adc9ff893b5cdc157b4dc2937f69.png";